import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
//ChatRoom01
//ScreenStageLeft
const CameraLocationsDB = [
    {
        cameraLocationId: 'M01T03',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'The Black Story: Curatorial Statement',
        ObjectId:null,
    },
    {
        cameraLocationId: 'M01V03',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'A short film by Nick Pezzillo - Video',
        ObjectId:null,
    },
    {
        cameraLocationId: 'A02P01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Afrozaa Jamil Konka',
        ObjectId:null,
    },
    {
        cameraLocationId: 'A03P01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Alakesh Ghosh',
        ObjectId:null,
    },
    {
        cameraLocationId: 'A01P04',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Bishwajit Goswami',
        ObjectId:null,
    },
    {
        cameraLocationId: 'A04P01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Kanak Chanpa Chakma',
        ObjectId:null,
    },
    {
        cameraLocationId: 'A05P01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Sourav Chowdhury',
        ObjectId:null,
    },
    {
        cameraLocationId: 'M01V01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Still I Rise by Maya Angelou - Video',
        ObjectId:null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'M01V02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'I Can’t Breathe by Isaiah Boozer - Video',
        ObjectId:null,
        displayMesh: 'N',
    },
    // {
    //     cameraLocationId: '',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: '',
    //     ObjectId:null,
    // },
];

export {CameraLocationsDB, FLOOR_NUMBER};
